<script>
import Cookies from 'js-cookie';
import JetNavLink from '@/Jetstream/NavLink.vue';

export default {
  name: 'DeviceSetupAlertMixin',
  components: { JetNavLink },

  data() {
    return {
      alertIsVisible: false,
      deviceSetup: this.$page.props.deviceSetup,
      sessionLifetime: this.$page.props.sessionLifetime / (24 * 60),
    };
  },

  mounted() {
    if (this.currentPageCanContainAlerts()) {
      const deviceSetupCompleted = this.checkIfDeviceSetupCompleted();

      if (deviceSetupCompleted) {
        this.alertIsVisible = false;
      } else {
        this.checkIfAlertWasClosed();
      }
    }
  },
  methods: {
    getLinkToDashboardPage() {
      switch (this.$page.props.user.role) {
        case 'clinician':
        case 'admin':
          return route('dashboard.clinician');
        default:
          return route('dashboard');
      }
    },

    getLinkToDeviceSetupPage() {
      return route('clinician.device-session-setup');
    },

    currentPageCanContainAlerts() {
      const availablePages = [this.getLinkToDashboardPage()];
      const currentPageUrl = window.location.href;

      return availablePages.includes(currentPageUrl);
    },

    closeAlert() {
      this.alertIsVisible = false;
      this.createOrUpdateCookie();
    },

    checkIfDeviceSetupCompleted() {
      return !Object.values(this.deviceSetup).some((value) => value === null);
    },

    getDevicesToSetup() {
      return Object.entries(this.$page.props.deviceSetup)
        .filter(([, value]) => value === null)
        .map(([key]) => key);
    },

    checkIfAlertWasClosed() {
      if (Cookies.get(this.alertSeenCookieName)) {
        this.closeAlert();
      } else {
        this.alertIsVisible = true;
      }
    },

    createOrUpdateCookie() {
      Cookies.set(this.alertSeenCookieName, 'true', { expires: this.sessionLifetime });
    },
  },
};
</script>
